<template>
  <IndexBase
    @auth="onAuth($event)"
    action="Index"
    controller="Work"
  ></IndexBase>

  <Card>
    <template #title>
      <Toolbar>
        <template #left>
          <div class="p-card-title">Work</div>
        </template>
        <template #right>
          <!-- <Button class="pi-button p-button-info" :label="$t('permit')" icon="pi pi-eye"
                                v-if="selectedRow"
                                @click="processSelectedData($PERMIT.RELEASE)" /> -->
          <Permit
            :data="selectedRow"
            v-if="selectedRow"
            @close="onModalClose"
            @message="sidebarMessage($event)"
          />
        </template>
      </Toolbar>
    </template>

    <template #content>
      <div class="p-fluid mb-3">
        <CustomSelectButton
          v-model="selectedType"
          :options="typeList"
          optionLabel="option"
          class="p-text-center"
          @change="onTypeChange"
          :setDefault="true"
        >
          <template #option="slotProps">
            <div class="p-text-center" style="width: 100%">
              {{ slotProps.option }}
            </div>
          </template>
        </CustomSelectButton>
      </div>

      <DataTable
        ref="dt"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        filterDisplay="row"
        sortMode="multiple"
        removableSort
        v-model:expandedRows="expandedRows"
        stateStorage="local"
        :stateKey="stateKey"
        :value="dataModel"
        :loading="!dataModel || loading"
        :paginator="true"
        :rows="pageSize"
        :lazy="true"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        v-model:first="this.start"
        @rowExpand="onRowExpand"
        @state-restore="onStateRestore($event)"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        @update:selection="onSelect($event)"
        v-model:filters="filters"
        :totalRecords="totalRecords"
        v-model:selection="selectedRow"
        selectionMode="single"
        dataKey="Id"
        :rowClass="rowClass"
        :metaKeySelection="false"
        id="dataWork"
      >
        <Column
          :exportable="false"
          :sortable="false"
          headerStyle="white-space:nowrap"
        >
          <template #header="">
            <Button
              :label="$t('create')"
              icon="pi pi-plus"
              v-show="canCreate"
              class="p-button-primary p-button-sm"
              @click="initWork(this.$FORM_MODE_CREATE, 0)"
            />
          </template>
          <template #filter>
            <Button
              :label="$t('clear')"
              icon="pi pi-filter-slash"
              class="p-button-outlined p-button-primary p-button-sm"
              @click="clearFilter"
              :badge="filterBadge"
              badgeClass="p-badge-danger"
            />
          </template>
          <template #body="dataModel">
            <Button
              icon="pi pi-pause"
              v-if="
                this.companyUser == dataModel.data.VendorCode &&
                dataModel.data.Status == this.$STATUS_WORK.OPN &&
                dataModel.data.IsDeleted == 'N'
              "
              class="p-button-rounded p-button-warning mr-2 p-button-sm"
              @click="confirm($event, this.$RUN_WORK.PAUSE, dataModel.data.Id)"
              v-tooltip.bottom="'Pause'"
            />

            <Button
              icon="pi pi-check"
              v-if="
                this.companyUser == dataModel.data.VendorCode &&
                dataModel.data.Status == this.$STATUS_WORK.OPN &&
                dataModel.data.IsDeleted == 'N'
              "
              class="p-button-rounded p-button-success mr-2 p-button-sm"
              @click="
                confirm($event, this.$RUN_WORK.CONFIRM, dataModel.data.Id)
              "
              v-tooltip.bottom="'Confirm'"
            />

            <Button
              icon="pi pi-times"
              v-if="
                this.companyUser == dataModel.data.VendorCode &&
                dataModel.data.Status == this.$STATUS_WORK.PND &&
                dataModel.data.IsDeleted == 'N'
              "
              class="p-button-rounded p-button-danger mr-2 p-button-sm"
              @click="confirm($event, this.$RUN_WORK.CANCEL, dataModel.data.Id)"
              v-tooltip.bottom="'Cancel'"
            />

            <Button
              icon="pi pi-play"
              v-if="
                this.companyUser == dataModel.data.VendorCode &&
                dataModel.data.Status == this.$STATUS_WORK.DRF &&
                dataModel.data.IsDeleted == 'N'
              "
              class="p-button-rounded p-button-success mr-2 p-button-sm"
              @click="confirm($event, this.$RUN_WORK.START, dataModel.data.Id)"
              v-tooltip.bottom="'Start'"
            />

            <Button
              icon="pi pi-times"
              v-if="
                this.companyUser == dataModel.data.VendorCode &&
                dataModel.data.Status == this.$STATUS_WORK.CNF &&
                dataModel.data.IsDeleted == 'N'
              "
              class="p-button-rounded p-button-danger mr-2 p-button-sm"
              @click="
                confirm(
                  $event,
                  this.$RUN_WORK.CANCEL_CONFIRM,
                  dataModel.data.Id
                )
              "
              v-tooltip.bottom="'Cancel'"
            />

            <Button
              icon="pi pi-undo"
              v-if="
                this.companyUser == dataModel.data.VendorCode &&
                dataModel.data.Status == this.$STATUS_WORK.CLS &&
                dataModel.data.IsDeleted == 'N'
              "
              class="p-button-rounded p-button-warning mr-2 p-button-sm"
              @click="confirm($event, this.$RUN_WORK.REVISE, dataModel.data.Id)"
              v-tooltip.bottom="'Revise'"
            />

            <Button
              icon="pi pi-search"
              v-show="canView"
              class="p-button-rounded p-button-info mr-2 p-button-sm"
              @click="editor(this.$FORM_MODE_VIEW, dataModel.data.Id)"
              v-tooltip.bottom="'View'"
            />
            <Button
              icon="pi pi-pencil"
              v-show="
                canEdit &&
                dataModel.data.Status == this.$STATUS_WORK.DRF &&
                dataModel.data.IsDeleted == 'N'
              "
              class="p-button-rounded p-button-success mr-2 p-button-sm"
              @click="editor(this.$FORM_MODE_EDIT, dataModel.data.Id)"
              v-tooltip.bottom="'Edit'"
              v-if="
                this.username == dataModel.data.WorkUser &&
                dataModel.data.IsDeleted == 'N'
              "
            />
            <Button
              icon="pi pi-trash"
              v-if="
                (dataModel.data.Status == this.$STATUS_WORK.OPN ||
                  dataModel.data.Status == this.$STATUS_WORK.DRF) &&
                dataModel.data.WorkUser == this.username &&
                dataModel.data.IsDeleted == 'N'
              "
              class="p-button-rounded p-button-danger mr-2 p-button-sm"
              @click="editor(this.$FORM_MODE_DELETE, dataModel.data.Id)"
              v-tooltip.bottom="'Delete'"
            />

            <Button
              icon="pi pi-undo"
              v-if="dataModel.data.IsDeleted == 'Y' && this.isAdmin == 'Y'"
              class="p-button-rounded p-button-danger mr-2 p-button-sm"
              @click="
                confirm($event, this.$RUN_WORK.CANCEL_DELETE, dataModel.data.Id)
              "
              v-tooltip.bottom="'Cancel Delete'"
            />

            <ConfirmPopup></ConfirmPopup>
          </template>
        </Column>
        <Column field="WorkNumber" :header="$t('work_number')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('work_number')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="DateOpen"
          :header="$t('date_open')"
          dataType="date"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              placeholder="Start Open"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDate(data.DateOpen) }}
          </template>
        </Column>
        <Column field="Status" :header="$t('status')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('status')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="VendorCode" :header="$t('excecutor')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('excecutor')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="CompanyCode" :header="$t('owner')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('owner')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="AreaName" :header="$t('location')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('location')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="Title" :header="$t('title')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('title')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="CreatedAt"
          :header="$t('created_date')"
          dataType="date"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              inputMask="99/99/9999"
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              @date-select="filterCallback()"
              placeholder="Created Date"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDateTime(data.CreatedAt) }}
          </template>
        </Column>

        <Column field="CreatedBy" :header="$t('created_by')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
              placeholder="Created By"
            />
          </template>
        </Column>
        <Column
          field="EditedAt"
          :header="$t('edited_date')"
          dataType="date"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              placeholder="Edited Date"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDateTime(data.EditedAt) }}
          </template>
        </Column>
        <Column field="EditedBy" :header="$t('edited_by')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
              placeholder="Edited By"
            />
          </template>
        </Column>
        <Column field="IsDeleted" :header="$t('is_deleted')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <YNSelect
              :placeholder="$t('is_deleted')"
              :useBinary="true"
              v-if="filterModel"
              v-model="filterModel.value"
              @change="filterCallback()"
            />
          </template>
        </Column>
        <Column field="DeletedAt" :header="$t('deleted_date')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              inputMask="99/99/9999"
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              placeholder="Deleted Date"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDateTime(data.DeletedAt) }}
          </template>
        </Column>
        <Column field="DeletedBy" :header="$t('deleted_by')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
              placeholder="Deleted By"
            />
          </template>
        </Column>
      </DataTable>
    </template>
  </Card>

  <SelectCompany
    v-if="selectCompany"
    :isVisible="selectCompany"
    :userId="username"
    :requireCompany="true"
    @hide="hideSelectCompanyDialog"
    @block-ui="blockUI"
    @unblock-ui="unblockUI"
  />
</template>

<script>
import SelectCompany from "./_SelectCompany.vue";
import Permit from "./_Permit.vue";
export default {
  name: "Work",
  components: {
    SelectCompany: SelectCompany,
    Permit: Permit,
  },
  data() {
    return {
      dataModel: null,
      loading: true,
      totalRecords: 0,
      start: 0,
      stateKey: this.$STATE_NAME + "work-" + this.$store.getters.getUsername,
      role: this.$store.getters.getRole,
      isAdmin: this.$store.getters.getIsAdmin,
      isUser: this.$store.getters.getIsUser,
      isTransporter: this.$store.getters.getIsTransporter,
      isDriver: this.$store.getters.getIsDriver,
      companyUser: this.$store.getters.getCompanyCode,
      username: this.$store.getters.getUsername,
      sorts: null,
      lazyParams: {},
      pageSize: 10,
      filters: null,
      workData: null,
      stateFilters: null,
      typeUrl: "work/status",
      editorPath: "/Work/Editor",
      dataUrl: "work/list",
      dataStartUrl: "work/run",
      dataCancelStarUrl: "work/cancel",
      dataPauseUrl: "work/pause",
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canView: false,
      selectCompany: false,
      selectedRow: null,
      viewPermitList: false,
      selectedType: null,
      showApprovalConfirmationModal: false,
      selectedCategoryIndex: 0,
    };
  },
  methods: {
    onAuth(event) {
      this.canCreate = event.canCreate;
      this.canEdit = event.canEdit;
      this.canDelete = event.canDelete;
      this.canView = event.canView;
    },
    rowClass(data) {
      if (data.IsDeleted == "Y") {
        return "classRed";
      }
    },
    onPage(event) {
      this.pageSize = event.rows;
      this.start = event.first;
      this.loadLazyData();
    },
    onSort(event) {
      this.sorts = event.multiSortMeta;
      this.loadLazyData();
    },
    onFilter() {
      this.loadLazyData();
    },
    onSelect(event) {
      //console.log(event)
      this.selectedRow = event.data;
    },
    onRowExpand(event) {
      this.expandedRows = [];
      this.expandedRows.push(event.data);
    },
    editor(mode, id) {
      this.$router.push({
        path: this.editorPath,
        query: { mode: mode, id: id },
      });
    },
    filter(mode) {
      this.$router.push({ path: this.filterPath, query: { mode: mode } });
    },
    sidebarMessage(event) {
      this.$toast.add(event);
    },
    loadLazyData() {
      this.loading = true;
      this.selectedRow = null;

      this.lazyParams = {
        start: this.start,
        pageSize: this.pageSize,
        sorts: this.dataSort,
        filters: this.dataFilter,
        category: this.selectedType,
      };

      var self = this;

      this.$axios
        .post(this.$API_URL + this.dataUrl, this.lazyParams)
        .then((response) => {
          if (response.data.success) {
            //console.log(response.data.data)
            this.dataModel = response.data.data;
            this.totalRecords = response.data.totalRecords;
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }

          this.loading = false;
        })
        .catch(function (err) {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
          self.loading = false;
        });
    },
    setFilters() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var filterValue = null;
        if (this.stateFilters) {
          var field = this.stateFilters[exportable[i].props.field];
          if (field) filterValue = field.value;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
    },
    onStateRestore(event) {
      this.start = event.first;
      this.pageSize = event.rows;
      this.stateFilters = event.filters;
      this.sorts = event.multiSortMeta;

      this.selectedCategoryIndex = event.selectedCategoryIndex ?? 0;
    },
    onStateSave(event) {
      event.selectedCategoryIndex = this.selectedCategoryIndex;
    },
    editOrder() {
      this.$router.push({
        path: this.editorPath,
        query: { mode: this.$FORM_MODE_EDIT, id: this.selectedRow[0].Id },
      });
    },
    onModalClose() {
      this.loadLazyData();
    },
    clearFilter() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var fieldName = exportable[i].props.field;
        var filterValue = "";
        if (fieldName.includes("Date")) {
          filterValue = null;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
      this.loadLazyData();
    },
    onTypeChange(event) {
      this.selectedType = event.value;
      this.selectedCategoryIndex = event.index;
      this.$refs.dt.triggerSaveState();
      this.setFilters();
      this.loadLazyData();
    },
    hideSelectCompanyDialog(event) {
      this.selectCompany = false;
      this.errormessage = "";
      this.onModalClose();
      if (event && event.success) {
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: event.message.message,
          life: 3000,
        });
        this.editor(this.$FORM_MODE_EDIT, event.message.data);
      }
    },
    confirm(event, mode, id) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.runWork(mode, id);
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    blockUI() {
      this.$emit("block-ui");
    },
    unblockUI() {
      this.$emit("unblock-ui");
    },
    initWork() {
      this.selectCompany = true;
    },
    runWork(mode, id) {
      this.blockUI();
      this.workData = {
        Id: id,
        modeWork: mode,
      };
      var self = this;
      this.$axios
        .post(this.$API_URL + "work/run", this.workData)
        .then((response) => {
          if (response) {
            if (response.data.success) {
              self.$toast.add({
                severity: "success",
                summary: "Success",
                detail: response.data.message,
                life: 3000,
              });
            } else {
              self.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.data.message,
                life: 3000,
              });
            }
            self.loadLazyData();
            this.unblockUI();
          } else {
            self.errormessage = response.message;
            self.processing = false;
            this.unblockUI();
          }
          self.loading = false;
        })
        .catch((error) => {
          self.errormessage = error;
          self.processing = false;
          self.loading = false;
        });
    },
    showError(summary, message) {
      this.$emit("unblock-ui");
      this.$toast.add({
        severity: "error",
        summary: summary,
        detail: message,
        life: 3000,
      });
    },
    processSelectedData(status) {
      this.viewPermitList = true;
      this.confirmationStatus = status;
    },
    confirmApproval() {
      this.$emit("blockBody");
      var self = this;

      self.invalid = false;

      // if (this.checkRemarks())
      //     return;

      var data = {
        data: this.selectedDocuments,
        status: this.confirmationStatus,
      };

      self.processing = true;

      this.$axios
        .put(this.$API_URL + this.releaseUrl, data)
        .then((response) => {
          self.processing = false;

          if (response) {
            this.$emit("unblockBody");
            if (response.data.success) {
              self.$toast.add({
                severity: "success",
                summary: "Data Saved",
                detail: response.data.message,
                life: 3000,
              });
              self.showApprovalConfirmationModal = false;
              self.processed = false;
              self.loadLazyData();
            } else {
              self.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.data.message,
                life: 3000,
              });
              self.showApprovalConfirmationModal = false;
              self.processed = false;
            }
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "No Response",
              life: 3000,
            });
          }
        })
        .catch(function (error) {
          self.processed = false;
          self.processing = false;

          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 3000,
          });
        });
    },
    dismissConfirmation() {
      this.processed = false;
      this.showApprovalConfirmationModal = false;
      this.loadLazyData();
    },
    checkRemarks() {
      var result = false;

      var self = this;
      self.invalid = false;

      // if (!this.selectedStatus.toLowerCase().includes("appointment")) {
      //     return false;
      // }

      // if (this.confirmationStatus == this.$APPROVAL_STATUS.APPROVED) {
      //     return false;
      // }

      for (var x = 0; x < this.selectedRow.length; x++) {
        var doc = this.selectedRow[x];

        if (doc.Remarks == "" || doc.Remarks == null) {
          self.invalid = true;
          result = true;
          break;
        }
      }

      return result;
    },
  },
  mounted() {
    this.$emit("unblock-ui");
    this.setFilters();

    var self = this;

    this.$axios
      .get(this.$API_URL + this.typeUrl)
      .then((response) => {
        //console.log(response)
        if (response.data.success) {
          self.typeList = response.data.data;
          var selectedTypeValue = Object.values(this.typeList)[
            this.selectedCategoryIndex
          ];
          if (selectedTypeValue == undefined) {
            self.selectedType = Object.values(this.typeList)[0];
          } else {
            self.selectedType = selectedTypeValue;
          }

          self.loadLazyData();
        } else {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.data.message,
            life: 3000,
          });
        }

        self.loading = false;
      })
      .catch(function (err) {
        //console.log(self);
        self.$toast.add({
          severity: "error",
          summary: "Error",
          detail: err,
          life: 3000,
        });
        self.loading = false;
      });
  },
  computed: {
    dataFilter() {
      var h = [];
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          h.push({
            field: key ? key : null,
            value: value.value,
            matchMode: value.matchMode,
          });
        }
      }
      return h;
    },
    dataSort() {
      var h = [];
      if (this.sorts) {
        for (var x = 0; x < this.sorts.length; x++) {
          h.push({
            field: this.sorts[x].field,
            order: this.sorts[x].order == 1 ? "ASC" : "DESC",
          });
        }
      }
      return h;
    },
    filterBadge() {
      var badgeNumber = 0;

      this.dataFilter.filter(function (item) {
        if (item.value && item.field != "Status") {
          badgeNumber++;
        }
      });

      return badgeNumber;
    },
    selectedDocuments() {
      var data = [];

      if (this.selectedRow == null) return data;

      for (var x = 0; x < this.selectedRow.length; x++) {
        var row = this.selectedRow[x];
        var d = {
          id: row.Id,
          remarks: row.WorkUser,
          ref_no: row.WorkNumber,
        };

        data.push(d);
      }

      return data;
    },
  },
};
</script>

<style #scoped>
.p-card .p-card-content {
  margin: 0 !important;
  padding: 0 !important;
}

#dataWork .classRed {
  background-color: #f85656 !important;
}
</style>
